
import React, { useState, useEffect } from 'react';



const ExperianScoreReportModal = ({
  isOpen,
  onClose,
  ExperianReport,
  Equifaxv2Error,
  displayMessageBlock = true,
  reportMessage = "",
  reportCode = "",
}) => {
  const [isPrinting, setIsPrinting] = useState(false);

  useEffect(() => {
    // console.log("Modal received exp2:", ExperianReport);
    //  console.log("Modal received exp2 error:", Equifaxv2Error);
  }, [ExperianReport], [Equifaxv2Error]);

  if (!isOpen) return null; // Do not render anything if not open

  const printDiv = () => {
    setIsPrinting(true);

    // Create a temporary window for printing
    const printWindow = window.open('', '', 'height=700,width=1000');

    const printContents = document.getElementById("invoicedata").innerHTML;

    // Write the content to the new window
    printWindow.document.write('<html><head><title>Print</title>');
    printWindow.document.write('<link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet">');
    printWindow.document.write('</head><body >');
    printWindow.document.write(printContents);
    printWindow.document.write('</body></html>');

    printWindow.document.close(); // Close the document for rendering
    printWindow.focus(); // Focus on the new window

    setTimeout(() => {
      printWindow.print(); // Trigger print
      setIsPrinting(false);
    }, 100);
  };




  const responses = ExperianReport?.CAIS_Account?.CAIS_Account_DETAILS;
  function convertDateForm(time) {
    let s = `${time}`;
    return s.slice(0, 4) + "/" + s.slice(4, 6) + "/" + s.slice(6, 8);
  }

  const safeGet = (obj, path, defaultValue = "N/A") => {
    if (!obj) return defaultValue;
    return path.split('.').reduce((current, key) => {
      return current && current[key] !== undefined && current[key] !== null ? current[key] : defaultValue;
    }, obj);
  };

  // Helper function to convert date
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    if (convertDateForm) return convertDateForm(dateString);
    return dateString;
  };

  const modalDataError = Equifaxv2Error && Equifaxv2Error;

  const stateCodeMap = {
    "01": "Jammu and Kashmir",
    "02": "Himachal Pradesh",
    "03": "Punjab",
    "04": "Chandigarh",
    "05": "Uttarakhand",
    "06": "Haryana",
    "07": "Delhi",
    "08": "Rajasthan",
    "09": "Uttar Pradesh",
    "10": "Bihar",
    "11": "Sikkim",
    "12": "Arunachal Pradesh",
    "13": "Nagaland",
    "14": "Manipur",
    "15": "Mizoram",
    "16": "Tripura",
    "17": "Meghalaya",
    "18": "Assam",
    "19": "West Bengal",
    "20": "Jharkhand",
    "21": "Odisha",
    "22": "Chhattisgarh",
    "23": "Madhya Pradesh",
    "24": "Gujarat",
    "25": "Daman and Diu",
    "26": "Dadra and Nagar Haveli",
    "27": "Maharashtra",
    "28": "Andhra Pradesh (Old)",
    "29": "Karnataka",
    "30": "Goa",
    "31": "Lakshadweep",
    "32": "Kerala",
    "33": "Tamil Nadu",
    "34": "Puducherry",
    "35": "Andaman and Nicobar Islands",
    "36": "Telangana",
    "37": "Andhra Pradesh",
    "97": "Other Territory",
    "99": "Other"
  };


const accountTypeMap = {
    "01" : "Auto - Loan (Personal)",
    "02" : "Housing Loan",
    "03" : "Property Loan",
    "04" : "Loan Against Shares/Securities",
    "05" : "Personal Loan",
    "06" : "Consumer Loan",
    "07" : "Gold Loan",
    "08" : "Education Loan",
    "09" : "Loan to Professional",
    "10" : "Credit Card",
    "11" : "Leasing",
    "12" : "Overdraft",
    "13" : "Two-Wheeler Loan",
    "14" : "Non-Funded Credit Facility",
    "15" : "Loan Against Bank Deposits",
    "16" : "Fleet Card",
    "17" : "Commercial Vehicle Loan",
    "18" : "Telco – Wireless",
    "19" : "Telco – Broadband",
    "20" : "Telco – Landline",
    "21" : "Seller Financing",
    "23" : "GECL Loan Secured",
    "24" : "GECL Loan Unsecured",
    "31" : "Secured Credit Card",
    "32" : "Used Car Loan",
    "33" : "Construction Equipment Loan",
    "34" : "Tractor Loan",
    "35" : "Corporate Credit Card",
    "36" : "Kisan Credit Card",
    "37" : "Loan on Credit Card",
    "38" : "Prime Minister Jaan Dhan Yojana – Overdraft",
    "39" : "Mudra Loans – Shishu/Kishor/Tarun",
    "40" : "Microfinance – Business Loan",
    "41" : "Microfinance – Personal Loan",
    "42" : "Microfinance – Housing Loan",
    "43" : "Microfinance – Others",
    "44" : "Pradhan Mantri Awas Yojana - Credit Link Subsidy Scheme MAY CLSS",
    "45" : "P2P Personal Loan",
    "46" : "P2P Auto Loan",
    "47" : "P2P Education Loan",
    "50" : "Business Loan – Secured",
    "51" : "Business Loan – General",
    "52" : "Business Loan – Priority Sector – Small Business",
    "53" : "Business Loan – Priority Sector – Agriculture",
    "54" : "Business Loan – Priority Sector – Others",
    "55" : "Business Non-Funded Credit Facility – General",
    "56" : "Business Non-Funded Credit Facility-Priority Sector- Small Business",
    "57" : "Business Non-Funded Credit Facility-Priority Sector-Agriculture",
    "58" : "Business Non-Funded Credit Facility-Priority Sector-Others",
    "59" : "Business Loan Against Bank Deposits",
    "61" : "Business Loan – Unsecured",
    "69" : "Short Term Personal Loan",
    "70" : "Priority Sector- Gold Loan",
    "71" : "Temporary Overdraft",
    "00" : "Other"
};



  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center z-50 backdrop-blur-sm bg-white bg-opacity-50 md:p-0 p-4">
      <div className="bg-white rounded-lg shadow-lg w-full md:max-w-3xl overflow-y-auto max-h-[100vh]" id="invoicedata">
        <div className="a4-page">
   

  {displayMessageBlock && (() => {
            const message =
              Equifaxv2Error?.error?.credit_report_message?.message ||
              Equifaxv2Error?.message ||
              ExperianReport?.message ||
              reportMessage ||
              "";

            const code =
              Equifaxv2Error?.error?.credit_report_message?.message_code ||
              Equifaxv2Error?.message_code ||
              ExperianReport?.message_code ||
              reportCode ||
              "";

            const isSuccess = message?.toLowerCase().includes("success");

            // 🛑 Don't show anything if it's success
            if (isSuccess) return null;

            const formatText = (text) =>
              text?.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

            return (
              <>{(message?.length > 0 || code?.length > 0) && (
                <div className="flex flex-col items-center justify-center my-2">
                  <div className="bg-red-50 border border-red-400 rounded-md p-1 w-full md:w-3/4">
                    <p className="text-center text-black font-bold">
                      Error: <span className="font-normal">{formatText(message)}</span>
                    </p>
                    <p className="text-center text-black font-bold mt-1">
                      Code: <span className="font-normal">{formatText(code)}</span>
                    </p>
                  </div>
                </div>
              )}
              </>

            );
          })()}




        
{/* Header Section - 100% Dynamic from JSON */}
<div className="grid grid-cols-12 items-center mb-1">
  {(() => {
    const formatKey = (key) => {
      return key
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
    };

    const formatDateValue = (value) => {
      if (!value) return 'N/A';
      const str = String(value);
      if (str.length === 8 && !isNaN(str)) {
        return `${str.substring(6, 8)}-${str.substring(4, 6)}-${str.substring(0, 4)}`;
      }
      return value;
    };

    const headerData = ExperianReport?.INProfileResponse?.CreditProfileHeader || 
                       ExperianReport?.CreditProfileHeader || {};

    const leftItems = [];
    const rightItems = [];
    const centerTitle = headerData.Subscriber_Name || 'Credit Report';

    // Dynamically build header info from JSON
    Object.entries(headerData).forEach(([key, value], idx) => {
      if (!value || key === 'Subscriber_Name') return;
      
      const formattedValue = key.includes('Date') ? formatDateValue(value) : 
                            key.includes('Time') && String(value).length === 6 ? 
                            `${String(value).substring(0, 2)}:${String(value).substring(2, 4)}:${String(value).substring(4, 6)}` : 
                            value;

      const item = (
        <p key={key} className="text-xs">
          <i className='font-semibold'>{formatKey(key)}:</i>
          <span className="ml-1">{formattedValue}</span>
        </p>
      );

      if (idx < 2) leftItems.push(item);
      else rightItems.push(item);
    });

    // Add client_id if exists
    if (ExperianReport?.client_id) {
      leftItems.unshift(
        <p key="client_id" className="text-xs">
          <i className='font-semibold'>Client Id:</i>
          <span className="ml-1">{ExperianReport.client_id}</span>
        </p>
      );
    }

    return (
      <>
        {/* Logo */}
        <div className="col-span-3 flex justify-start">
          <img
            src="https://www.experian.com/static/shared/logos/logo-experian.svg"
            className="w-24 p-1"
            alt="Logo"
          />
        </div>

        {/* Dynamic Title from JSON */}
        <div className="col-span-6 flex justify-center text-center">
          <h4 className="text-2xl font-bold">{centerTitle}</h4>
        </div>

        {/* Credit Score - Dynamic */}
        <div className="col-span-3 flex justify-end text-sm">
          {(ExperianReport?.SCORE?.BureauScore || ExperianReport?.credit_score) && (
            <>
              <span>{formatKey('credit_score')}:</span>
              <strong className="text-xl ml-1">
                {ExperianReport?.SCORE?.BureauScore || ExperianReport?.credit_score}
              </strong>
            </>
          )}
        </div>
      </>
    );
  })()}
</div>

{/* Report Details - 100% Dynamic */}
<div className="flex justify-between items-start flex-wrap mb-1">
  {(() => {
    const formatKey = (key) => {
      return key
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
    };

    const formatDateValue = (value) => {
      if (!value) return 'N/A';
      const str = String(value);
      if (str.length === 8 && !isNaN(str)) {
        return `${str.substring(6, 8)}-${str.substring(4, 6)}-${str.substring(0, 4)}`;
      }
      return value;
    };

    const headerData = ExperianReport?.INProfileResponse?.CreditProfileHeader || 
                       ExperianReport?.CreditProfileHeader || {};

    const leftItems = [];
    const rightItems = [];

    // Add client_id
    if (ExperianReport?.client_id) {
      leftItems.push(
        <p key="client_id" className="text-xs">
          <i className='font-semibold'>{formatKey('client_id')}:</i>
          <span className="ml-1">{ExperianReport.client_id}</span>
        </p>
      );
    }

    // Dynamically add all header fields
    Object.entries(headerData).forEach(([key, value], idx) => {
      if (!value || key === 'Subscriber_Name') return;
      
      const formattedValue = key.includes('Date') ? formatDateValue(value) : 
                            key.includes('Time') && String(value).length === 6 ? 
                            `${String(value).substring(0, 2)}:${String(value).substring(2, 4)}:${String(value).substring(4, 6)}` : 
                            value;

      const item = (
        <p key={key} className="text-xs">
          <i className='font-semibold'>{formatKey(key)}:</i>
          <span className="ml-1">{formattedValue}</span>
        </p>
      );

      if (idx < 2) leftItems.push(item);
      else rightItems.push(item);
    });

    return (
      <>
        <div>{leftItems}</div>
        <div className="text-right">{rightItems}</div>
      </>
    );
  })()}
</div>

{/* Personal Details - 100% Dynamic from JSON */}
<div className='flex justify-center'>
  <p className='font-bold text-black text-sm'>Personal Details</p>
</div>

<div className="border border-blue-500 p-3 rounded-md mb-1">
  {(() => {
    const formatKey = (key) => {
      return key
        .replace(/_non_normalized/g, '')
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
    };

    const formatValue = (key, value) => {
      if (!value || value === '' || value === null) return null;

      // Date formatting
      if (key.includes('Date') && key.includes('Birth')) {
        const str = String(value);
        if (str.length === 8 && !isNaN(str)) {
          return `${str.substring(6, 8)}-${str.substring(4, 6)}-${str.substring(0, 4)}`;
        }
      }

      // Gender mapping
      if (key === 'Gender_Code') {
        const genderMap = { '1': 'Male', '2': 'Female', '3': 'Other' };
        return genderMap[value] || value;
      }

      return value;
    };

    // Get all possible sources
    const applicantDetails = ExperianReport?.INProfileResponse?.Current_Application?.Current_Application_Details?.Current_Applicant_Details ||
                            ExperianReport?.Current_Application?.Current_Application_Details?.Current_Applicant_Details || {};

    const otherDetails = ExperianReport?.INProfileResponse?.Current_Application?.Current_Application_Details?.Current_Other_Details ||
                        ExperianReport?.Current_Application?.Current_Application_Details?.Current_Other_Details || {};

    const addressDetails = ExperianReport?.INProfileResponse?.Current_Application?.Current_Application_Details?.Current_Applicant_Address_Details?.[0] ||
                          ExperianReport?.Current_Application?.Current_Application_Details?.Current_Applicant_Address_Details?.[0] || {};

    const caisHolder = ExperianReport?.CAIS_Account?.CAIS_Account_DETAILS?.[0]?.CAIS_Holder_Details?.[0] || {};
    const caisAddress = ExperianReport?.CAIS_Account?.CAIS_Account_DETAILS?.[0]?.CAIS_Holder_Address_Details?.[0] || {};

    // Merge all data sources
    const allDetails = {
      ...applicantDetails,
      ...otherDetails,
      ...addressDetails,
      ...caisHolder,
      ...caisAddress
    };

    // Add fallback fields
    if (ExperianReport?.name) allDetails.Name = ExperianReport.name;
    if (ExperianReport?.mobile) allDetails.Mobile = ExperianReport.mobile;
    if (ExperianReport?.pan) allDetails.Pan = ExperianReport.pan;
    if (modalDataError?.data?.name) allDetails.Name = allDetails.Name || modalDataError.data.name;
    if (modalDataError?.error?.name) allDetails.Name = allDetails.Name || modalDataError.error.name;

    const personalData = {};

    // Process all fields dynamically
    Object.entries(allDetails).forEach(([key, value]) => {
      const formattedValue = formatValue(key, value);
      if (formattedValue) {
        personalData[formatKey(key)] = formattedValue;
      }
    });

    if (Object.keys(personalData).length === 0) {
      return <p className="text-center text-gray-500 py-4">No personal details available</p>;
    }

    return (
      <div className="grid grid-cols-3 md:grid-cols-3 gap-1">
        {Object.entries(personalData).map(([key, value]) => (
          <div key={key}>
            <p className="text-sm">
              <i className="font-semibold">{key}:</i>
              <span className="ml-1">{value}</span>
            </p>
          </div>
        ))}
      </div>
    );
  })()}
</div>

<hr className="my-2" />

{/* Address Details - 100% Dynamic */}
<div className="bg-blue-900 text-white p-1 rounded-tr-xl rounded-tl-xl text-sm font-semibold">
  Address Details
</div>

{(() => {
  const addresses = ExperianReport?.INProfileResponse?.Current_Application?.Current_Application_Details?.Current_Applicant_Address_Details ||
                   ExperianReport?.Current_Application?.Current_Application_Details?.Current_Applicant_Address_Details || [];

  const hasData = (value) => {
    if (value === null || value === undefined || value === '') return false;
    if (Array.isArray(value)) return value.length > 0;
    if (typeof value === 'object') return Object.keys(value).length > 0;
    return true;
  };

  const formatFieldName = (key) => {
    return key
      .replace(/_non_normalized/g, '')
      .replace(/_/g, ' ')
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  const renderCellValue = (value) => {
    if (!hasData(value)) return '-';
    
    if (Array.isArray(value)) {
      return value.map((item, idx) => (
        <div key={idx} className="mb-1">
          {typeof item === 'object' ? JSON.stringify(item) : item}
        </div>
      ));
    }
    
    if (typeof value === 'object' && value !== null) {
      return (
        <div className="text-xs">
          {Object.entries(value).map(([k, v], idx) => (
            <div key={idx}>
              <span className="font-semibold">{formatFieldName(k)}:</span> {v || '-'}
            </div>
          ))}
        </div>
      );
    }
    
    return value;
  };

  if (!Array.isArray(addresses) || addresses.length === 0) {
    return (
      <div className="border border-blue-900 rounded-br-md rounded-bl-md p-4 text-center text-gray-500">
        No address details available
      </div>
    );
  }

  // Get all unique keys dynamically
  const allKeys = new Set();
  addresses.forEach(addr => {
    if (addr && typeof addr === 'object') {
      Object.keys(addr).forEach(key => allKeys.add(key));
    }
  });

  const displayKeys = Array.from(allKeys).filter(key => {
    return addresses.some(addr => hasData(addr?.[key]));
  });

  if (displayKeys.length === 0) {
    return (
      <div className="border border-blue-900 rounded-br-md rounded-bl-md p-4 text-center text-gray-500">
        No address details available
      </div>
    );
  }

  return (
    <div className="border border-blue-900 rounded-br-md rounded-bl-md overflow-hidden mb-3">
      <div className="overflow-x-auto">
        <table className="w-full border-collapse text-xs">
          <thead className="bg-blue-100">
            <tr>
              <th className="border border-gray-300 px-2 py-1 text-left font-semibold text-blue-900">
                S.No.
              </th>
              {displayKeys.map((key) => (
                <th key={key} className="border border-gray-300 px-2 py-1 text-left font-semibold text-blue-900">
                  {formatFieldName(key)}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white">
            {addresses.map((addr, idx) => (
              <tr key={idx} className={idx % 2 === 0 ? 'bg-gray-50' : 'bg-white'}>
                <td className="border border-gray-300 px-2 py-1 font-medium text-gray-700">
                  {idx + 1}
                </td>
                {displayKeys.map((key) => (
                  <td key={key} className="border border-gray-300 px-2 py-1 text-gray-600">
                    {renderCellValue(addr?.[key])}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
})()}





<div className="bg-blue-900 text-white p-2 mt-2 rounded-tr-xl rounded-tl-xl text-sm font-semibold">
  Experian Score
</div>
{(() => {
  const scoreData = ExperianReport?.SCORE;

  // Return null if no score data
  if (!scoreData || typeof scoreData !== 'object') return null;

  // Helper to check if field has data (MODIFIED to be more lenient)
  const hasValue = (val) => {
    if (val === undefined) return false; // Only exclude undefined
    if (typeof val === 'string' && val.trim() === '') return false;
    if (Array.isArray(val)) return val.length > 0;
    if (typeof val === 'object' && val !== null) return Object.keys(val).length > 0;
    return true; // This will allow null values to pass through
  };

  // Helper to format field names
  const formatLabel = (key) => {
    return key
      .replace(/([A-Z])/g, ' $1') // Add space before capital letters
      .replace(/_/g, ' ')
      .trim()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  // Get main score field (typically BureauScore, Score, CreditScore, etc.)
  const scoreKeys = ['BureauScore', 'Score', 'CreditScore', 'CIBIL_Score', 'Experian_Score'];
  const mainScoreKey = Object.keys(scoreData).find(key => scoreKeys.includes(key)) || 
                        Object.keys(scoreData).find(key => key.toLowerCase().includes('score'));
  
  const scoreValue = mainScoreKey ? scoreData[mainScoreKey] : null;

  // Get all other fields (exclude arrays/objects and main score)
  const allKeys = Object.keys(scoreData);
  const detailFields = allKeys.filter(key => {
    if (key === mainScoreKey) return false; // Skip main score
    const value = scoreData[key];
    // Only exclude arrays and nested objects, but allow null/undefined primitives
    if (Array.isArray(value)) return false;
    if (typeof value === 'object' && value !== null) return false;
    return true; // Show all primitive fields including null
  });

  // Don't render if no fields at all
  if (!mainScoreKey && detailFields.length === 0) return null;

  // Color coding based on score value
  const getScoreColor = (score) => {
    const numScore = parseInt(score);
    if (isNaN(numScore)) return { bg: 'bg-green-800', text: 'text-white', border: 'border-gray-400' };
    if (numScore >= 750) return { bg: 'bg-green-800', text: 'text-white', border: 'border-green-600' };
    if (numScore >= 650) return { bg: 'bg-green-800', text: 'text-white', border: 'border-yellow-600' };
    if (numScore >= 550) return { bg: 'bg-green-800', text: 'text-white', border: 'border-orange-600' };
    return { bg: 'bg-red-100', text: 'text-red-900', border: 'border-red-600' };
  };

  const scoreColors = getScoreColor(scoreValue);

  // Helper to render cell value
  const renderValue = (val) => {
    if (val === null || val === undefined) return '-';
    return val;
  };

  return (
    <div className="border border-blue-900 rounded-br-xl rounded-bl-xl overflow-hidden mb-2">
      <div className="overflow-x-auto">
        <table className="w-full border-collapse text-xs">
          <thead className="bg-blue-100">
            <tr>
             
              {detailFields.map((key, idx) => (
                <th key={idx} className="border border-gray-300 px-2 py-1 text-left font-semibold text-blue-900">
                  {formatLabel(key)}
                </th>
              ))}
               {mainScoreKey && (
                <th className="border border-gray-300 px-3 py-2 text-left font-semibold text-blue-900">
                  {formatLabel(mainScoreKey)}
                </th>
              )}
            </tr>
          </thead>
          <tbody className="bg-white">
            <tr>
              
              {detailFields.map((key, idx) => (
                <td key={idx} className="border border-gray-300 px-2 py-1 text-gray-700 font-medium">
                  {renderValue(scoreData[key])}
                </td>
              ))}
              {mainScoreKey && (
                <td className="border border-gray-300 px-2 py-1.5">
                  <div className={`flex flex-col items-center justify-center ${scoreColors.bg} rounded-lg ${scoreColors.border} border-2 p-2 w-14 h-14 mx-auto`}>
                    <span className={`text-2xl font-bold ${scoreColors.text}`}>
                      {renderValue(scoreValue)}
                    </span>
                    <span className={`text-[10px] font-semibold ${scoreColors.text}`}>
                      Score
                    </span>
                  </div>
                </td>
              )}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
})()}





          {/* Account Details Section */}
          <div className="bg-blue-900 md:text-white text-white p-1 mt-2 rounded-tr-xl rounded-tl-xl text-sm">Account Details</div>

 
<table className="min-w-full table-auto text-left mt-2 border-collapse">
  <tbody>
    {responses && Array.isArray(responses) && responses.length > 0 && (
      <tr>
        <td colSpan={6} className="px-1 py-0">
          <div className="flex flex-col gap-3 mt-1">
            {responses.map((LinkedAC, idx) => {
              const typeCode = LinkedAC?.Account_Type || "N/A";
              const accountTypeName = accountTypeMap[typeCode] || "Not Specified";

              // FIXED: Better hasValue check (handles 0 and false correctly)
              const hasValue = (val) => {
                if (val === null || val === undefined) return false;
                if (typeof val === 'string' && val.trim() === '') return false;
                if (Array.isArray(val) && val.length === 0) return false;
                if (typeof val === 'object' && !Array.isArray(val) && Object.keys(val).length === 0) return false;
                return true;
              };

              // Helper to check if value is a non-empty array
              const isArray = (val) => Array.isArray(val) && val.length > 0;

              // Helper to format field names
              const formatLabel = (key) => {
                return key
                  .replace(/_/g, ' ')
                  .split(' ')
                  .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                  .join(' ');
              };

              // Helper to format value with proper styling
              const formatValue = (key, value) => {
                if (key.includes('Amount') || key.includes('Balance') || key.includes('Credit') || key.includes('Loan')) {
                  const amount = parseFloat(value) || 0;
                  const colorClass = key.includes('Past_Due') || key.includes('Written_Off') 
                    ? (amount > 0 ? 'text-red-600' : 'text-green-600')
                    : 'text-blue-600';
                  return <span className={`${colorClass} font-semibold`}>₹{amount}</span>;
                }
                
                if (key.includes('Date') && typeof value === 'string' && value.length === 8) {
                  return <span className="text-gray-700 font-semibold">{formatDate(value)}</span>;
                }

                if (key.includes('Interest') || key.includes('Rate')) {
                  return <span className="text-purple-600 font-semibold">{value}%</span>;
                }

                if (key === 'Account_Type') {
                  return <span className="text-yellow-600 font-semibold">{accountTypeName}</span>;
                }

                return <span className="text-gray-700 font-semibold">{value}</span>;
              };

              // Fields to skip (already shown elsewhere or redundant)
              const fieldsToSkip = ['Payment_History_Profile'];

              // DYNAMIC: Automatically separate main fields and nested arrays
              const allKeys = Object.keys(LinkedAC || {});
              const mainFields = [];
              const nestedArrays = [];

              allKeys.forEach(key => {
                // Skip specific fields
                if (fieldsToSkip.includes(key)) return;

                const value = LinkedAC[key];
                if (isArray(value)) {
                  nestedArrays.push({ key, data: value });
                } else if (hasValue(value)) {
                  mainFields.push(key);
                }
              });

              // Function to render ANY nested array as table
              const renderNestedTable = (data, title) => {
                if (!Array.isArray(data) || data.length === 0) return null;

                // Get all keys from all objects in array
                const allNestedKeys = new Set();
                data.forEach(item => {
                  if (item && typeof item === 'object') {
                    Object.keys(item).forEach(key => allNestedKeys.add(key));
                  }
                });

                // Filter to show only fields with data
                const displayKeys = Array.from(allNestedKeys).filter(key => {
                  return data.some(item => hasValue(item?.[key]));
                });

                if (displayKeys.length === 0) return null;

                return (
                  <div className="mt-3 border-t pt-2">
                    <p className="font-bold mb-2 text-sm text-gray-800">{title}</p>
                    <div className="overflow-x-auto">
                      <table className="w-full border-collapse text-xs">
                        <thead className="bg-blue-100">
                          <tr>
                            <th className="border border-gray-300 px-2 py-1 text-left font-semibold text-blue-900 w-12">S.No.</th>
                            {displayKeys.map((key, kidx) => (
                              <th key={kidx} className="border border-gray-300 px-2 py-1 text-left font-semibold text-blue-900">
                                {formatLabel(key)}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody className="bg-white">
                          {data.map((item, itemIdx) => (
                            <tr key={itemIdx} className={itemIdx % 2 === 0 ? 'bg-gray-50' : 'bg-white'}>
                              <td className="border border-gray-300 px-2 py-1 font-medium text-gray-700">{itemIdx + 1}</td>
                              {displayKeys.map((key, keyIdx) => (
                                <td key={keyIdx} className="border border-gray-300 px-2 py-1 text-gray-600">
                                  {item?.[key] || '-'}
                                </td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                );
              };

              return (
                <div key={idx} className="w-full border rounded-md p-1 bg-white shadow-sm">
                  {/* Heading */}
                  <h3 className="bg-blue-900 text-white p-1 rounded-tr-xl rounded-tl-xl text-sm font-semibold">
                    Loan Type: {accountTypeName}
                  </h3>

                  {/* Main Account Details Grid */}
                  {mainFields.length > 0 && (
                    <div className="grid grid-cols-3 gap-2 mb-2 p-2 text-xs">
                      {mainFields.map((key, fieldIdx) => (
                        <div key={fieldIdx}>
                          <span className="font-semibold text-gray-600">{formatLabel(key)}:</span>{" "}
                          {formatValue(key, LinkedAC[key])}
                        </div>
                      ))}
                    </div>
                  )}

                  {/* DYNAMIC: Render ALL nested arrays automatically */}
                  {nestedArrays.map((arr, arrIdx) => (
                    <React.Fragment key={arrIdx}>
                      {arr.key === 'CAIS_Account_History' ? (
                        <PaymentHistoryLists history={arr.data} />
                      ) : (
                        renderNestedTable(arr.data, formatLabel(arr.key))
                      )}
                    </React.Fragment>
                  ))}
                </div>
              );
            })}
          </div>
        </td>
      </tr>
    )}
  </tbody>
</table>




<div class="overflow-y-auto">
  <table class="min-w-full border border-gray-200 text-xs">
    <thead class="bg-gray-100 sticky top-0">
      <tr>
        <th class="border border-gray-200 px-2 py-1 text-left w-14">Code</th>
        <th class="border border-gray-200 px-2 py-1 text-left">Account Type</th>
        <th class="border border-gray-200 px-2 py-1 text-left w-14">Code</th>
        <th class="border border-gray-200 px-2 py-1 text-left">Account Type</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td class="border border-gray-100 px-1 py-0">01</td>
        <td class="border border-gray-100 px-1 py-0">Auto - Loan (Personal)</td>
        <td class="border border-gray-100 px-1 py-0">02</td>
        <td class="border border-gray-100 px-1 py-0">Housing Loan</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">03</td>
        <td class="border border-gray-100 px-1 py-0">Property Loan</td>
        <td class="border border-gray-100 px-1 py-0">04</td>
        <td class="border border-gray-100 px-1 py-0">Loan Against Shares/Securities</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">05</td>
        <td class="border border-gray-100 px-1 py-0">Personal Loan</td>
        <td class="border border-gray-100 px-1 py-0">06</td>
        <td class="border border-gray-100 px-1 py-0">Consumer Loan</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">07</td>
        <td class="border border-gray-100 px-1 py-0">Gold Loan</td>
        <td class="border border-gray-100 px-1 py-0">08</td>
        <td class="border border-gray-100 px-1 py-0">Education Loan</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">09</td>
        <td class="border border-gray-100 px-1 py-0">Loan to Professional</td>
        <td class="border border-gray-100 px-1 py-0">10</td>
        <td class="border border-gray-100 px-1 py-0">Credit Card</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">11</td>
        <td class="border border-gray-100 px-1 py-0">Leasing</td>
        <td class="border border-gray-100 px-1 py-0">12</td>
        <td class="border border-gray-100 px-1 py-0">Overdraft</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">13</td>
        <td class="border border-gray-100 px-1 py-0">Two-Wheeler Loan</td>
        <td class="border border-gray-100 px-1 py-0">14</td>
        <td class="border border-gray-100 px-1 py-0">Non-Funded Credit Facility</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">15</td>
        <td class="border border-gray-100 px-1 py-0">Loan Against Bank Deposits</td>
        <td class="border border-gray-100 px-1 py-0">16</td>
        <td class="border border-gray-100 px-1 py-0">Fleet Card</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">17</td>
        <td class="border border-gray-100 px-1 py-0">Commercial Vehicle Loan</td>
        <td class="border border-gray-100 px-1 py-0">18</td>
        <td class="border border-gray-100 px-1 py-0">Telco – Wireless</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">19</td>
        <td class="border border-gray-100 px-1 py-0">Telco – Broadband</td>
        <td class="border border-gray-100 px-1 py-0">20</td>
        <td class="border border-gray-100 px-1 py-0">Telco – Landline</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">21</td>
        <td class="border border-gray-100 px-1 py-0">Seller Financing</td>
        <td class="border border-gray-100 px-1 py-0">23</td>
        <td class="border border-gray-100 px-1 py-0">GECL Loan Secured</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">24</td>
        <td class="border border-gray-100 px-1 py-0">GECL Loan Unsecured</td>
        <td class="border border-gray-100 px-1 py-0">31</td>
        <td class="border border-gray-100 px-1 py-0">Secured Credit Card</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">32</td>
        <td class="border border-gray-100 px-1 py-0">Used Car Loan</td>
        <td class="border border-gray-100 px-1 py-0">33</td>
        <td class="border border-gray-100 px-1 py-0">Construction Equipment Loan</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">34</td>
        <td class="border border-gray-100 px-1 py-0">Tractor Loan</td>
        <td class="border border-gray-100 px-1 py-0">35</td>
        <td class="border border-gray-100 px-1 py-0">Corporate Credit Card</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">36</td>
        <td class="border border-gray-100 px-1 py-0">Kisan Credit Card</td>
        <td class="border border-gray-100 px-1 py-0">37</td>
        <td class="border border-gray-100 px-1 py-0">Loan on Credit Card</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">38</td>
        <td class="border border-gray-100 px-1 py-0">Prime Minister Jaan Dhan Yojana – Overdraft</td>
        <td class="border border-gray-100 px-1 py-0">39</td>
        <td class="border border-gray-100 px-1 py-0">Mudra Loans – Shishu/Kishor/Tarun</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">40</td>
        <td class="border border-gray-100 px-1 py-0">Microfinance – Business Loan</td>
        <td class="border border-gray-100 px-1 py-0">41</td>
        <td class="border border-gray-100 px-1 py-0">Microfinance – Personal Loan</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">42</td>
        <td class="border border-gray-100 px-1 py-0">Microfinance – Housing Loan</td>
        <td class="border border-gray-100 px-1 py-0">43</td>
        <td class="border border-gray-100 px-1 py-0">Microfinance – Others</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">44</td>
        <td class="border border-gray-100 px-1 py-0">
          Pradhan Mantri Awas Yojana - Credit Link Subsidy Scheme MAY CLSS
        </td>
        <td class="border border-gray-100 px-1 py-0">45</td>
        <td class="border border-gray-100 px-1 py-0">P2P Personal Loan</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">46</td>
        <td class="border border-gray-100 px-1 py-0">P2P Auto Loan</td>
        <td class="border border-gray-100 px-1 py-0">47</td>
        <td class="border border-gray-100 px-1 py-0">P2P Education Loan</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">50</td>
        <td class="border border-gray-100 px-1 py-0">Business Loan – Secured</td>
        <td class="border border-gray-100 px-1 py-0">51</td>
        <td class="border border-gray-100 px-1 py-0">Business Loan – General</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">52</td>
        <td class="border border-gray-100 px-1 py-0">
          Business Loan – Priority Sector – Small Business
        </td>
        <td class="border border-gray-100 px-1 py-0">53</td>
        <td class="border border-gray-100 px-1 py-0">
          Business Loan – Priority Sector – Agriculture
        </td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">54</td>
        <td class="border border-gray-100 px-1 py-0">
          Business Loan – Priority Sector – Others
        </td>
        <td class="border border-gray-100 px-1 py-0">55</td>
        <td class="border border-gray-100 px-1 py-0">
          Business Non-Funded Credit Facility – General
        </td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">56</td>
        <td class="border border-gray-100 px-1 py-0">
          Business Non-Funded Credit Facility – Priority Sector – Small Business
        </td>
        <td class="border border-gray-100 px-1 py-0">57</td>
        <td class="border border-gray-100 px-1 py-0">
          Business Non-Funded Credit Facility – Priority Sector – Agriculture
        </td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">58</td>
        <td class="border border-gray-100 px-1 py-0">
          Business Non-Funded Credit Facility – Priority Sector – Others
        </td>
        <td class="border border-gray-100 px-1 py-0">59</td>
        <td class="border border-gray-100 px-1 py-0">
          Business Loan Against Bank Deposits
        </td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">61</td>
        <td class="border border-gray-100 px-1 py-0">Business Loan – Unsecured</td>
        <td class="border border-gray-100 px-1 py-0">69</td>
        <td class="border border-gray-100 px-1 py-0">Short Term Personal Loan</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">70</td>
        <td class="border border-gray-100 px-1 py-0">Priority Sector- Gold Loan</td>
        <td class="border border-gray-100 px-1 py-0">71</td>
        <td class="border border-gray-100 px-1 py-0">Temporary Overdraft</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">00</td>
        <td class="border border-gray-100 px-1 py-0">Other</td>
        <td class="border border-gray-100 px-1 py-0"></td>
        <td class="border border-gray-100 px-1 py-0"></td>
      </tr>
    </tbody>
  </table>
</div>



{/* Summary Section */}
<div className="bg-blue-900 text-white p-2 mt-2 rounded-tr-xl rounded-tl-xl text-sm font-semibold">
  Summary
</div>

<div className="min-w-full border border-gray-300 p-2 text-xs grid grid-cols-2 gap-2">
  {(() => {
    // Helper function to format keys - removes underscores and capitalizes
    const formatKey = (key) => {
      if (!key) return '';
      return key
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
    };

    // Helper function to format values
    const formatValue = (value) => {
      if (value === null || value === undefined) return 'N/A';
      if (typeof value === 'boolean') return value ? 'Yes' : 'No';
      if (typeof value === 'number') return value.toLocaleString('en-IN');
      return String(value);
    };

    // Helper to assign color based on key
    const getValueColor = (key) => {
      if (!key) return "text-gray-700";
      const lower = key.toLowerCase();
      if (lower.includes('active')) return "text-blue-600 font-semibold";
      if (lower.includes('outstanding') || lower.includes('balance') || lower.includes('total')) 
        return "text-green-600 font-bold";
      if (lower.includes('default') || lower.includes('overdue') || lower.includes('suit') || lower.includes('closed')) 
        return "text-red-600 font-semibold";
      if (lower.includes('new') || lower.includes('percentage')) 
        return "text-yellow-600 font-semibold";
      if (lower.includes('secured') || lower.includes('unsecured')) 
        return "text-purple-600 font-semibold";
      return "text-gray-700";
    };

    // Recursive function to flatten nested objects
    const flattenObject = (obj, prefix = '') => {
      const result = [];
      
      if (!obj || typeof obj !== 'object') return result;

      Object.entries(obj).forEach(([key, value]) => {
        // Skip if value is null or undefined
        if (value === null || value === undefined) return;

        // If value is an object (not array), recurse deeper
        if (typeof value === 'object' && !Array.isArray(value)) {
          // Check if this object has primitive values (leaf node)
          const hasOnlyPrimitives = Object.values(value).every(
            v => typeof v !== 'object' || v === null
          );

          if (hasOnlyPrimitives) {
            // This is a leaf object, extract all key-value pairs
            Object.entries(value).forEach(([subKey, subValue]) => {
              result.push([subKey, subValue]);
            });
          } else {
            // Continue recursing
            result.push(...flattenObject(value, prefix ? `${prefix}_${key}` : key));
          }
        } else if (Array.isArray(value)) {
          // Handle arrays (if needed in future)
          result.push([key, `${value.length} items`]);
        } else {
          // Primitive value
          result.push([prefix ? `${prefix}_${key}` : key, value]);
        }
      });

      return result;
    };

    // Get the CAIS_Summary data
    const caisSummary = safeGet(ExperianReport, 'CAIS_Account.CAIS_Summary');
    
    if (!caisSummary || typeof caisSummary !== 'object') {
      return (
        <div className="col-span-2 text-gray-500 text-center py-4">
          No summary data available
        </div>
      );
    }

    // Flatten all nested data
    const flattenedData = flattenObject(caisSummary);

    if (flattenedData.length === 0) {
      return (
        <div className="col-span-2 text-gray-500 text-center py-4">
          No summary data available
        </div>
      );
    }

    return flattenedData.map(([key, value], i) => (
      <div key={`summary-${i}`} className="flex justify-between border-b border-gray-200 pb-1">
        <span className="font-semibold text-gray-600">{formatKey(key)}</span>
        <span className={getValueColor(key)}>{formatValue(value)}</span>
      </div>
    ));
  })()}
</div>



           
          <div className='mt-4'>
  <h3 className="text-green-800 text-center font-bold">END of Report  {" "}
                  :{" "}
                 {safeGet(ExperianReport, 'Current_Application.Current_Application_Details.Current_Applicant_Details.First_Name')
                    || modalDataError?.data?.name ||
                    modalDataError?.name ||
                    modalDataError?.error?.name || "N/A"
                  }
    
    </h3>
</div>
        </div>

        
      </div>
      <div className="flex justify-center mt-4 gap-2">
          <button
            className="bg-green-500 text-white p-2 rounded hover:bg-green-700"
            onClick={printDiv}
            disabled={isPrinting}
          >
            Print
          </button>
          <button
            className="bg-red-500 text-white p-2 rounded hover:bg-red-700"
            onClick={onClose}
          >
            Close
          </button>
        </div>
    </div>
  );
};


const PaymentHistoryLists = ({ history }) => {
  if (!history || !Array.isArray(history) || history.length === 0) {
    return null;
  }

  // Known classification map (with proper colors)
  const classificationMap = {
    'S': { color: 'bg-green-500', label: 'Standard', textColor: 'text-green-700' },
    'D': { color: 'bg-red-500', label: 'Default', textColor: 'text-red-700' },
    'P': { color: 'bg-yellow-400', label: 'Past Due', textColor: 'text-yellow-700' },
    'X': { color: 'bg-blue-500', label: 'Special', textColor: 'text-blue-700' },
    'N': { color: 'bg-gray-400', label: 'Not Reported', textColor: 'text-gray-700' },
    // Additional common codes
    'SUB': { color: 'bg-orange-400', label: 'Sub-Standard', textColor: 'text-orange-700' },
    'DBT': { color: 'bg-purple-500', label: 'Doubtful', textColor: 'text-purple-700' },
    'LSS': { color: 'bg-pink-500', label: 'Loss', textColor: 'text-pink-700' },
    'STD': { color: 'bg-green-500', label: 'Standard', textColor: 'text-green-700' }
  };

  // Helper to get config for any classification (including unknown)
  const getClassificationConfig = (code) => {
    if (classificationMap[code]) {
      return classificationMap[code];
    }
    // Default for unknown classifications
    return {
      color: 'bg-gray-500',
      label: code || 'Unknown',
      textColor: 'text-gray-700'
    };
  };

  // Collect all unique classifications from actual data
  const uniqueClassifications = new Set();
  history.forEach(item => {
    const code = item.Asset_Classification || 'N';
    uniqueClassifications.add(code);
  });

  return (
    <div className="w-full mb-2 p-2 bg-gray-50 rounded-md">
      <p className="font-bold mb-2 text-sm text-gray-800">Payment History</p>
      
      {/* History Timeline */}
      <div className="flex flex-wrap gap-2">
        {history.map((item, idx) => {
          const classification = item.Asset_Classification || 'N';
          const monthYear = `${item.Month}/${item.Year}`;
          const config = getClassificationConfig(classification);

          return (
            <div
              key={idx}
              className="flex flex-col items-center p-1 border border-gray-300 rounded-md w-16 text-center bg-white hover:shadow-md transition-shadow"
              title={`${config.label} - ${monthYear}${item.Days_Past_Due ? ` (${item.Days_Past_Due} days)` : ''}`}
            >
              <div className={`w-5 h-5 rounded-full mb-1 ${config.color} shadow-sm`}></div>
              <span className="text-[11px] font-medium text-gray-700">{monthYear}</span>
              <span className={`text-[9px] ${config.textColor} font-semibold`}>{classification}</span>
              {item.Days_Past_Due && (
                <span className="text-[8px] text-red-600">{item.Days_Past_Due}d</span>
              )}
            </div>
          );
        })}
      </div>

      {/* Dynamic Legend - Only show classifications that appear in data */}
      <div className="flex gap-2 mt-3 text-xs flex-wrap border-t pt-2">
        {Array.from(uniqueClassifications).sort().map((code) => {
          const config = getClassificationConfig(code);
          return (
            <div key={code} className="flex items-center gap-1">
              <div className={`w-3 h-3 rounded-full ${config.color}`}></div>
              <span className="text-gray-700">{config.label} ({code})</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};


export default ExperianScoreReportModal;
